$(document).ready(function() {

    setInterval(function() {
    var data = $('.swym-anchor-badge.show-badge').attr('data-count');
      if (data >= 10) {
          $('.wishlist-count').html('9+');
      } else {
          $('.wishlist-count').html(data);
      }
      console.log('data',data);
    }, 1500);

    // your product card markup
    var productTileMarkup = `
	
  `;

    function swymCallbackFn() {
        var wishlistItemsContainer = document.getElementById("wishlist-items");
        if (wishlistItemsContainer) {
            window._swat.fetchWrtEventTypeET(
                function(wishlistProducts) {
                    wishlistProducts.forEach(function(wishlistProduct) {
                        wishlistProduct.isInCart = _swat.platform.isInDeviceCart(wishlistProduct.epi);
                        var renderedProductTile = SwymUtils.renderTemplateString(productTileMarkup, wishlistProduct);
                        wishlistItemsContainer.insertAdjacentHTML('beforeend', renderedProductTile);
                    });

                    attachClickListeners();
                },
                window._swat.EventTypes.addToWishList
            );
        } else {
            attachClickListeners();
        }
    }
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);


    function attachClickListeners() {
        $(".add-to-cart").on("click", function(e) {
            e.preventDefault();
            var productId = e.target.getAttribute("data-product-id");
            var variantId = e.target.getAttribute("data-variant-id");
            var du = e.target.getAttribute("data-url");
            e.target.innerHTML = "Moving..";
            window._swat.replayAddToCart({
                    empi: productId,
                    du: du
                },
                variantId,
                function() {
                    e.target.innerHTML = "Moved to cart";
                    window.location.reload();
                    console.log("Successfully added product to cart.");
                },
                function(e) {
                    console.log(e);
                }
            );
        });
    }


    function onSwymLoadCallback(swat) {
        if (swat) {
            let onSuccess = function(lists) {
                console.log("Fetched all Lists", lists);
                let mainLid = lists[0]['lid'];
                let data = lists[0]['listcontents'];
                let count = lists[0]['cnt'];
                // alert(count);
                data.forEach(function(item) {

                    let product_div = $(document).find("#wishlist-items");

                    let productLid = item['lid'];
                    let productId = item['empi'];
                    let varientId = item['epi'];
                    let productName = item['dt'];
                    let price = item['pr'];
                    var productImage = item['iu'];

                    if (productImage) {
                        var productImage = item['iu'];
                    } else {
                        var productImage = 'https://borrasoutdoor.myshopify.com/cdn/shop/files/download_1042e708-5813-4e42-adfe-6f9a2f2582a7.jpg';
                    }


                    let productUrl = item['du'];
                    $('#clear-list').attr('data-id', mainLid);
                    var product_html = '<li class="grid__item">' +
                        '<div class="card-wrapper_whislist">' +
                        '<a href="' + productUrl + '" class="full-unstyled-link">' +
                        '<div class="card__media">' +
                        '<div class="media_whislist">' +
                        '<img src="' + productImage + '">' +
                        '</div>' +
                        '</div>' +
                        '<div class="card__information">' +
                        '<h3 class="card__heading card__heading h5 tw-font-sans tw-uppercase">' + productName + '</h3>' +
                        '</div>' +
                        '<div class="card-information">' +
                        '<div class="price">' +
                        '<div class="price__container">' +
                        '<div class="price__regular">' +
                        '<span class="price-item price-item--regular price__container tw-text-sm tw-leading-none">' + price + '</span>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</a>' +
                        '</div>' +
                        '<a href="javascrip:void(0)" class="add_to_cart_btn" style="display: inline-block; padding: 10px; margin: 5px; text-decoration: none; border-radius: 4px; background-color: white; color: #726869; border: 1px solid #726869; transition: background-color 0.3s; text-align: center; width: calc(50% - 10px);"><span id="add-to-cart" class="add-to-cart" pro-id="' + productId + '" data-id="' + varientId + '" pro-url="' + productUrl + '" qty="1">Add to cart</span></a>' +
                        '<a href="javascript:void(0)" class="remove_btn" style="display: inline-block; padding: 10px; margin: 5px; text-decoration: none; border-radius: 4px; background-color: #726869; color: white; border: 1px solid #726869; transition: background-color 0.3s; text-align: center; width: calc(50% - 10px);"><span id="remove" class="remove-to-list" pro-id="' + productId + '" data-id="' + varientId + '" pro-url="' + productUrl + '" pro-lid="' + productLid + '">Remove</span></a>' +
                        '</li>';
                    //    product_div.append(product_html); 
                    $('.btn_items').show();
                    // console.log('ProductId', item['empi'] + ',' + 'VarientId', item['epi'] + ',' + 'ProductName',item['dt'] + ',' + 'price',item['pr'] + ',' + 'image',item['iu'] + ',' + 'product_url',item['du']);


                    if (count >= 10) {
                        $('.wishlist-count').html('9+');
                    } else {
                        $('.wishlist-count').html(count);
                    }
                    console.log(count);
                });

            }

            let onError = function(error) {
                console.log("Error while fetching all Lists", error);
            }

            swat.fetchLists({
                callbackFn: onSuccess,
                errorFn: onError
            });
        }




    }

    function onSwymLoadCallbackN(swat) {
        if (swat) {
            let onSuccess = function(lists) {

                let mainLid = lists[0]['lid'];
                var productIds = [];
                var VarientIds = [];
                let data = lists[0]['listcontents'];
                data.forEach(function(item) {
                    let productId = item['empi'];
                    VarientIds.push(item['epi']);

                });

                $('.fefefefferewfddferedf').html(`<input type="hidden" id="eewfeffeffrwddewffef" value="${JSON.stringify(VarientIds)}">`);
                return VarientIds;
            }

            let onError = function(error) {
                console.log("Error while fetching all Lists", error);
            }

            swat.fetchLists({
                callbackFn: onSuccess,
                errorFn: onError
            });
        }
    }

    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    $(document).on('click', 'body', function() {
        window.SwymCallbacks.push(onSwymLoadCallbackN);

    });
    window.SwymCallbacks.push(onSwymLoadCallback);

    // list remove
    $(document).on('change', '#name', function() {

        if (!$(this).val().trim()) {
            $('.fnameerror').html(`<span>Name is Required</span>`);
        } else {
            $('.fnameerror').html('');
        }
    });
    $(document).on('change', '#email', function() {

        if (!$(this).val().trim()) {
            $('.femailerror').html(`<span>Email is Required</span>`);
        } else {
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

            if (reg.test($(this).val()) == false) {
                $('.femailerror').html(`<span>Invalid Email Address</span>`);
                return false;
            } else {

                $('.femailerror').html('');
            }

        }
    });
    $(document).on('change', '#phone', function() {

        if (!$(this).val().trim()) {
            $('.fphoneerror').html(`<span>Phone is Required</span>`);
        } else {

            var input = $(this).val();
            const phoneRegex = /^\+?\d{1,3}?\(?\d{0,4}\)?\s?\d+([-.\s]?\d+)*$/;

            // Check if input contains only letters
            const lettersOnly = /^[a-zA-Z]+$/.test(input);

            // Validate against the phone number regex and ensure input is not letters only
            if (!lettersOnly && phoneRegex.test(input)) {
                $('.fphoneerror').html('');
                return true;
            } else {
                $('.fphoneerror').html(`<span>Invalid Phone Number</span>`);
            }
        }
    });



    $(document).on('click', 'body', function() {

    });
    $(document).on('click', '#remove', function() {
        var proId = $(this).attr('pro-id');
        var dataId = $(this).attr('data-id');
        var proUrl = $(this).attr('pro-url');
        var proLid = $(this).attr('pro-lid');

        function onSwymLoadCallback(swat) {
            if (swat) {
                let lid = proLid;
                let product = {
                    epi: dataId,
                    empi: proId,
                    du: proUrl
                };
                let onSuccess = function(deletedProduct) {
                    location.reload();
                    console.log("Successfully deleted the Product", deletedProduct);
                }
                let onError = function(error) {
                    console.log("Error while deleting the Product", error);
                }
                swat.deleteFromList(lid, product, onSuccess, onError);
            }
        }
        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(onSwymLoadCallback);
        // alert('pro-id: ' + proId + '\ndata-id: ' + dataId + '\npro-url: ' + proUrl + '\npro-lid: ' + proLid);
    });

    // all list remove
    $(document).on('click', '#clear-list', function() {
        var dataId = $(this).attr('data-id');

        function onSwymLoadCallback(swat) {
            if (swat) {
                let lid = dataId;
                let onSuccess = function(deletedListObj) {
                    location.reload();
                    console.log(`Successfully deleted the List, ${lid}`, deletedListObj);
                }
                let onError = function(error) {
                    console.log(`Error while deleting the List, ${lid}`, error);
                }
                swat.deleteList(lid, onSuccess, onError);
            }
        }

        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }

        window.SwymCallbacks.push(onSwymLoadCallback);

        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(onSwymLoadCallback);
    });

    // add to cart
    $(document).on('click', '#add-to-cart', function() {
        console.log('add to cart');
        var proId = $(this).attr('pro-id');
        var dataId = $(this).attr('data-id');
        var proUrl = $(this).attr('pro-url');
        var proLid = $(this).attr('pro-lid');
        var qty = $(this).attr('qty');
        conosle.log('proId');
        function onSwymLoadCallback(swat) {
            if (swat) {
                swat.replayAddToCart({
                        empi: proId,
                        du: proUrl,
                        qty: qty
                    }, dataId,
                    (success) => {
                        const variant = JSON.parse(success).items[0];
                        const productTitle = variant.title;
                        let successMessage = `<strong>${productTitle}</strong> has been added to cart!`;

                        // Show success notifcation with error description on sucessful add to cart
                        swat.ui.showSuccessNotification({
                            message: successMessage
                        });
                    },
                    (error) => {
                        // Show error notifcation with error description on unsucessful add to cart
                        swat.ui.showErrorNotification({
                            message: error.description
                        });
                    }
                );
            }
        }
        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(onSwymLoadCallback);
        // alert('pro-id: ' + proId + '\ndata-id: ' + dataId + '\npro-url: ' + proUrl + '\npro-lid: ' + proLid);
    });


    setInterval(function() {
        var item_count = $('.johnstone--wishlist .swym-wishlist-grid li').length;

        if (item_count >= 10) {
            $('.johnstone--wishlist .wishlist-count').html('9+');
        } else {
            $('.johnstone--wishlist .wishlist-count').html(item_count);
        }
    }, 2000);



    // POPUP


    $('.all_location_grid').html('');
    $('#step2 .location_image_grid').html('');
    $('#step2 .step_heading').html('');
    // $('#step2 .location_deatils_grid').html('');

    $('#step2 .addressLocation').html('');
    $('#step2 .locationPhone').html('');
    $('#step2 .locationEmail').html('');
    $('#step2 .location_map_head').html('');

    $('#step2 .location_image_grid').html('');
    fetch("https://personalshoppingatjohnstonsofelgin.com/Johnstons/api/get_location", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                getProduct: "1"
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
            if (data.status) {

                for (variable of data.location) {

                    localStorage.setItem("location" + variable.id, JSON.stringify(variable));
                    $('.all_location_grid').append(`
              <button class="location_btn  button button--secondary" fdprocessedid="xuewss${variable.id}" location="${variable.id}">${variable.location_name}</button>
      `);
                }
            }
        })
        .catch(error => {
            console.error('There has been a problem with your fetch operation:', error);
        });
    const $popup = $('#popup');
    const $openPopupBtn = $('#openPopup');
    const $closeBtn = $('.close');
    const $steps = $('.step');
    const $nextBtns = $('.next');
    const $previousBtns = $('.previous');
    const $finishBtn = $('.finish');
    const $loactionSelected = $('.location_btn')
    let currentStep = 0;


    $openPopupBtn.on('click', function() {
        $popup.show();
        showStep(currentStep);
        $('body').css('overflowY', 'hidden');
    });

    $closeBtn.on('click', function() {
        $popup.hide();
        resetSteps();
        $('body').css('overflowY', 'unset');
    });

    $nextBtns.on('click', function() {

        if (currentStep == 0 || currentStep == "0") {
            if ($('#step1 button.location_btn.button.button--secondary.active').html() !== undefined && $('#step1 button.location_btn.button.button--secondary.active').html() !== null) {
                $('#step1 .errorstep1').html('');
                currentStep++;
                showStep(currentStep);
            } else {
                $('#step1 .errorstep1').html('Please Select Location');
            }

        } else if (currentStep == 2 || currentStep == "2") {
            var name = $('#name').val();
            var email = $('#email').val();
            var phone = $('#phone').val();

            $('.error').html('');
            var errorCheck = false;

            if (!name.trim()) {
                $('.fnameerror').html(`<span>Name is Required</span>`);
                errorCheck = true;
            }

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!email.trim()) {
                $('.femailerror').html(`<span>Email is Required</span>`);
                errorCheck = true;
            } else if (!emailPattern.test(email.trim())) {
                $('.femailerror').html(`<span>Invalid Email Address</span>`);
                errorCheck = true;
            }

            var input = phone;
            const phoneRegex = /^\+?\d{1,3}?\(?\d{0,4}\)?\s?\d+([-.\s]?\d+)*$/;

            // Check if input contains only letters
            const lettersOnly = /^[a-zA-Z]+$/.test(input);

            // Validate against the phone number regex and ensure input is not letters only

            if (!phone.trim()) {
                $('.fphoneerror').html(`<span>Phone is Required</span>`);
                errorCheck = true;
            } else if (lettersOnly || !phoneRegex.test(input)) {
                $('.fphoneerror').html(`<span>Invalid Phone Number</span>`);
                errorCheck = true;
            }

            if (errorCheck) {
                return;
            } else {
                $('.submit_btn svg').hide();
                $('.submit_btn .spinner:empty').show();
                $('.submit_btn').prop('disabled', true);
                var allvariant = $('#eewfeffeffrwddewffef').val();
                var locationId = $('button.location_btn.button.button--secondary.active').attr('location');

                var data = {
                    name: name,
                    email: email,
                    phone: phone,
                    variantId: allvariant,
                    locationId: locationId
                };

                $.ajax({
                    url: "https://personalshoppingatjohnstonsofelgin.com/Johnstons/api/get_location",
                    method: "POST",
                    data: JSON.stringify(data),
                    dataType: 'json',
                    contentType: "application/json",
                    success: function(result, status, jqXHR) {
                        if (result.status) {

                            $('.submit_btn').prop('disabled', false);
                        }
                    },
                    error(jqXHR, textStatus, errorThrown) {
                        //Do something
                    }
                });
                currentStep++;
                showStep(currentStep);
            }


        } else {
            currentStep++;
            showStep(currentStep);
        }

    });

    $previousBtns.on('click', function() {
        currentStep--;
        showStep(currentStep);
    });

    $finishBtn.on('click', function() {
        $popup.hide();
        resetSteps();
    });

    $(document).on('click', '.step_btn .button[type="submit"]', function(event) {
        event.preventDefault();
    });

    $(document).on('click', '.location_btn', function() {

        $(this).addClass('active').siblings().removeClass('active');
        var locationId = $(this).attr('location');

        var locationData = localStorage.getItem("location" + locationId);
        var selectLocationData = JSON.parse(locationData);
        $('#step2 .location_image_grid').html('');
        $('#step2 .step_heading').html('');
        // $('#step2 .location_deatils_grid').html('');

        $('#step2 .addressLocation').html('');
        $('#step2 .locationPhone').html('');
        $('#step2 .locationEmail').html('');
        $('#step2 .location_map_head').html('');
        console.log(selectLocationData.opening_hours);
        $('#step2 .location_image_grid').html('');
        $('#step2 .step_heading').html(selectLocationData.location_name);
        var opening_hours = selectLocationData.opening_hours;

        if (opening_hours !== '' && opening_hours !== null) {
            opening_hours = opening_hours.toLowerCase();

            const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

            days.forEach(day => {
                const regex = new RegExp(day + ":", "g");
                opening_hours = opening_hours.replace(regex, `${day.charAt(0).toUpperCase() + day.slice(1)}:</li><li>`);
            });

            opening_hours = opening_hours.replace(/pm/g, "PM</li><li>");

            // Update the HTML content
            $('#step2 .location_deatils_grid').html(`<li>` + opening_hours + `</li>`);
        }


        $('#step2 .addressLocation').html(selectLocationData.address);
        $('#step2 .locationPhone').html(`<a href="tel:${selectLocationData.phone}">${selectLocationData.phone}</a>`);
        $('#step2 .locationEmail').html(` <a href="mailto:${selectLocationData.phone}">${selectLocationData.email}</a>`);
        $('#step2 .location_map_head').html(`<iframe src="${selectLocationData.location_url}" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`);
        var imgUrls = JSON.parse(selectLocationData.location_image);
        if (imgUrls !== undefined && imgUrls !== null && imgUrls !== '') {
            for (imgUrl of imgUrls) {
                $('#step2 .location_image_grid').append(`<div> <img src="https://personalshoppingatjohnstonsofelgin.com/Johnstons/public/images/${imgUrl}" alt="Discover Johnstons of Elgin" width="100%" height="" loading="lazy"></div>`);
            }

        }
        $('#step1 .errorstep1').html('');
    });

    function showStep(step) {
        $steps.each(function(index) {
            $(this).toggleClass('active', index === step);
        });
    }

    function resetSteps() {
        currentStep = 0;
        showStep(currentStep);
    }




    // SECTION SCROLL TO TOP
    $('.btn_scroll_top').on('click', function() {
        $('.location_deatils_warpper').animate({
            scrollTop: 0
        }, 500);
    });




});